import { Auth, Form, Layout } from 'connex-cds';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { formConfig } from './form-config';
import { LinkSection } from './LinkSection';
import LoginForm from './LoginForm';

const { useAuthContext } = Auth;
const { Column, Container } = Layout;
const { FormProvider } = Form;

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuthContext();

  const handleLogin = React.useCallback(
    async (...args) => {
      const response = await login(...args);

      if (!response?.error) {
        navigate('/', { replace: true, state: location.state });
      }
    },
    [location.state, login, navigate]
  );

  return (
    <Column className="content" style={{ height: '100%' }}>
      <FormProvider onSubmit={handleLogin} config={formConfig}>
        <Container style={{ margin: 'auto', minWidth: '350px', padding: '25px' }}>
          <LoginForm />
        </Container>
        <LinkSection />
      </FormProvider>
    </Column>
  );
};

export default Login;
